export default __webpack_public_path__ + "static/media/notificationWhite.33ae75cc.svg";